import React, { useContext, useRef, useState, useEffect } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router";
import axios from "axios";
import buildLink from "../../../urls";
import { PlaySounds } from "../../../functions/playSounds";
import { CompanyContext } from "../../../contexts/companyCotext";
import MessageAlert from "../../../components/messageAlert";
import Loader from "../../../components/loader";
import Select from "react-select";
import { getDetectedOrderType } from "../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../axiosServer";

function ScannLogisticsOrder() {
  const history = useNavigate();
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const logisticsId = useRef(null);
  const orderId = useRef(null);
  const [stateCom] = useContext(CompanyContext);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [show, setShow] = useState(true);
  const [message, setMessage] = useState("");
  const [numberofpackages, setnumberofpackages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [numPackage, setNumPackage] = useState(1);
  const [splitScanProgress, setSplitScanProgress] = useState(null);

  var host = window.location.host;
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];
  const [orderType, setOrderType] = useState(options[0]);
  const [formData, setFormData] = useState({
    order_id: "",
    logistics_id: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    const order_id = orderId.current.value.trim();
    syncPackageFlowVisibility(order_id);
  };
  useEffect(() => {
    logisticsId.current.focus();
  }, []);

  const syncPackageFlowVisibility = (value = "") => {
    const shouldShowPackageFlow = !value.trim().includes("-");
    setShow(shouldShowPackageFlow);

    if (shouldShowPackageFlow && value.trim()) {
      setSplitScanProgress(null);
    }

    if (!shouldShowPackageFlow) {
      setnumberofpackages(null);
      // if (orderId.current) {
      //   orderId.current.value = "";
      // }
    }
  };

  const resetPackageFlow = () => {
    setShow(true);
    setnumberofpackages(null);
    setSplitScanProgress(null);
  };

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
  };

  async function ScanLogisticsOrder(e) {
    e.preventDefault();

    let detectedOrderType = orderType;

    const order_id = orderId.current.value.trim();
    const logistics_id = logisticsId.current.value.trim();
    orderId.current.value = order_id;
    logisticsId.current.value = logistics_id;
    syncPackageFlowVisibility(order_id);

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(order_id);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setOrderType(type);
    }

    let order_type;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      order_type = detectedOrderType === "return" ? 1 : 0;
    } else {
      order_type = orderType.value === "return" ? 1 : 0;
    }

    if (
      orderType == null &&
      host !== "pda.ishtari.com" &&
      host !== "pda.ishtari.com.gh" &&
      !host.startsWith("localhost")
    ) {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Order Type is Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    if (logistics_id === "") {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Logistic ID is  Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    if (order_id === "") {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Order ID is Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    setLoading(true);
    try {
      const user_id = stateCom?.userID;
      const obj = {
        order_id,
        logistics_id,
        user_id: user_id,
        order_type: order_type,
      };
      const isSplitOrderId = order_id.includes("-");
      let url;
      if (isSplitOrderId) {
        url = buildLink("scannLogisticsOrderV2");
      } else {
        url = buildLink("scannLogisticsOrder");
      }
      const response = await axiosServer.post(url, obj);
      orderId.current.value = "";
      orderId.current.focus();

      if (isSplitOrderId) {
        updateSplitScanProgress(
          response?.data?.package_scan ?? response?.data?.data,
        );
        setMessage(
          response?.data?.scanned_summary || response?.data?.message || "",
        );
        setnumberofpackages(null);

        if (response.data.success) {
          if (response?.data?.completed) {
            setShow(true);
          }
          playSuccessSound();
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          playErrorSound();
          setShowMessageErr(true);
          setTimeout(() => setShowMessageErr(false), 3000);
        }

        return;
      }

      if (response.data.success) {
        setMessage(response?.data?.scanned_summary);
        if (response.data.nb_package) {
          if (response?.data?.nb_package > response?.data?.nb_package_scanned) {
            let nb_of_package = Number(response?.data?.nb_package);
            let nb_package_scanned = Number(response?.data?.nb_package_scanned);
            let nb = nb_of_package - nb_package_scanned;
            setnumberofpackages(nb);

            playErrorSound();

            setShowMessageErr(true);
            setTimeout(() => {
              setShowMessageErr(false);
            }, 3000);
          } else {
            let nb_of_package = Number(response?.data?.nb_package);
            let nb_package_scanned = Number(response?.data?.nb_package_scanned);
            let nb = nb_of_package - nb_package_scanned;
            setnumberofpackages(nb);

            playSuccessSound();

            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
          }
        } else {
          if (isSplitOrderId) {
            updateSplitScanProgress(
              response?.data?.package_scan ?? response?.data?.data,
            );
          }
          setnumberofpackages("");
        }
      } else {
        playErrorSound();
        setMessage(response?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
    } catch (err) {
      playErrorSound();
      updateSplitScanProgress(
        err?.response?.data?.package_scan ?? err?.response?.data?.data,
      );
      orderId.current.value = "";
      orderId.current.focus();
      setnumberofpackages(null);
      setShowMessageErr(true);
      setMessage(err?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
    } finally {
      setLoading(false);
    }
  }

  const handleTrashClick = (type) => {
    if (type === "orderId") {
      orderId.current.value = "";
      resetPackageFlow();
      orderId.current.focus();
    } else if (type === "logisticId") {
      logisticsId.current.value = "";
      logisticsId.current.focus();
    }
  };

  async function orderIDFocus(e) {
    e.preventDefault();

    if (logisticsId.current.value === "") {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Logistic ID Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
    } else {
      orderId.current.focus();
    }
  }

  return (
    <div className=" h-full bg-white ">
      <div className=" z-30 mb-5 sticky top-0 flex flex-col ">
        <div className=" w-full bg-dbase h-16">
          <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
            <button onClick={() => history(-1)}>
              <FaArrowLeft />
            </button>
            <h2 className=" text-xl    my-auto">Scan Logistics Order</h2>
          </div>
        </div>
      </div>

      <div className="container flex flex-col gap-7">
        <form
          onSubmit={(e) => ScanLogisticsOrder(e)}
          className="flex flex-col gap-4"
        >
          {host !== "pda.ishtari.com" &&
            !host.startsWith("localhost") &&
            host !== "pda.ishtari.com.gh" && (
              <div>
                <div className="mb-1">Order Type</div>
                <Select
                  placeholder="Order Type"
                  value={orderType}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "6px",
                      borderColor: state.isFocused ? "#888" : "#ccc",
                      padding: "4px",
                      boxShadow: "none",
                    }),
                  }}
                  onChange={(selected) => setOrderType(selected)}
                  options={options}
                />
              </div>
            )}
          <div>
            <div>Logistic ID</div>
            <div className="relative w-full flex items-center mt-2">
              <input
                type="text"
                id="logistics_id"
                name="logistics_id"
                ref={logisticsId}
                onChange={handleChange}
                placeholder="Logistic Id"
                className="border border-dlabelColor outline-dbase w-full rounded-md py-2 pr-8 pl-2 text-d18"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    orderIDFocus(e);
                  }
                }}
              />
              <FaTrash
                className="absolute right-3 text-gray-400 hover:text-red-500 cursor-pointer transition-opacity duration-200 opacity-50"
                onClick={() => handleTrashClick("logisticId")}
              />
            </div>
          </div>
          <div>
            <div>Order ID</div>
            <div className="flex w-full gap-2">
              <div className="relative w-full flex items-center mt-2">
                <input
                  ref={orderId}
                  onChange={handleChange}
                  name="order_id"
                  type="text"
                  placeholder="Order ID"
                  className="border border-dlabelColor outline-dbase w-full rounded-md py-2 pr-8 pl-2 text-d18"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      ScanLogisticsOrder(e);
                    }
                  }}
                />
                <FaTrash
                  className="absolute right-3 text-gray-400 hover:text-red-500 cursor-pointer transition-opacity duration-200 opacity-50"
                  onClick={() => handleTrashClick("orderId")}
                />
              </div>

              <button
                type="submit"
                className="h-11 mt-2 px-4 rounded-md bg-dbase text-white text-sm font-medium hover:opacity-90 transition"
              >
                <div className="flex items-center gap-2">
                  {loading ? (
                    <Loader />
                  ) : numPackage > 1 || numPackage === 0 ? (
                    numPackage
                  ) : (
                    "Fetch"
                  )}
                </div>
              </button>
            </div>
          </div>

          {!show && splitScanProgress?.remainingPackages > 0 && (
            <div className="">
              <div className="p-1">Scanned:</div>
              <div className="space-x-3 flex flex-wrap">
                <input
                  value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                  readOnly
                  type="text"
                  className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                  placeholder="Scanned"
                />
              </div>
            </div>
          )}

          {show && (
            <div className="flex flex-col">
              <label class="mb-2">Remaining Packages:</label>
              <input
                readOnly
                value={numberofpackages}
                type="text"
                className="border  border-dlabelColor outline-dbase w-full rounded-md  py-2 pr-8  pl-2 bg-dplaceHolder"
                placeholder="Remaining Packages"
              />
            </div>
          )}
        </form>

        <div className="flex w-full gap-2"></div>
      </div>

      <MessageAlert
        message={message}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || (showMessgSucc && true)}
      />
    </div>
  );
}

export default ScannLogisticsOrder;
